// 文章详情(GVmbk / ARTd1)头部 moreBtn(ellipsis)→ BottomSheet 操作菜单。
//   - 作者:编辑文章(→ ARTed /article/:id/edit)/ 删除文章(红色,→ 二次确认 mdYih)
//   - 非作者:举报(→ DY9nl ReportModal,target = 文章作者)
// 沿用 BQOCz BottomSheet 视觉(handle bar + h-14 action row + 红色危险项)。
// 纯展示组件:实际跳转 / 删除 / 举报由父组件经回调处理。

import { useEffect } from 'react'

export type ArticleActionsSheetProps = {
  open: boolean
  onClose: () => void
  /** 当前用户是否为文章作者(决定展示编辑/删除 还是 举报)。 */
  isAuthor: boolean
  onEdit: () => void
  onDelete: () => void
  onReport: () => void
}

export function ArticleActionsSheet({
  open,
  onClose,
  isAuthor,
  onEdit,
  onDelete,
  onReport,
}: ArticleActionsSheetProps) {
  useEffect(() => {
    if (!open) return
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      data-frame-id="GVmbk-actions"
      data-testid="ARTd1-actions"
      role="dialog"
      aria-modal="true"
      aria-label="文章操作"
      className="fixed inset-0 z-50 flex items-end bg-black/50"
      onClick={onClose}
    >
      <div
        className="mx-auto w-full max-w-[402px] rounded-t-3xl bg-white"
        style={{ paddingBottom: 'max(34px, env(safe-area-inset-bottom))' }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HandleBar */}
        <div className="flex h-6 items-center justify-center">
          <span className="h-1 w-10 rounded-full bg-[#E5E7EB]" />
        </div>

        <ul className="flex flex-col pb-1">
          {isAuthor ? (
            <>
              <li>
                <button
                  type="button"
                  data-testid="ARTd1-edit"
                  onClick={onEdit}
                  className="flex h-14 w-full items-center gap-4 px-6 text-left active:bg-[#F6F7F8]"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                  </svg>
                  <span className="text-[16px] text-[#1A1A1A]">编辑文章</span>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  data-testid="ARTd1-delete"
                  onClick={onDelete}
                  className="flex h-14 w-full items-center gap-4 px-6 text-left active:bg-[#F6F7F8]"
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
                  </svg>
                  <span className="text-[16px] text-[#FF6B6B]">删除文章</span>
                </button>
              </li>
            </>
          ) : (
            <li>
              <button
                type="button"
                data-testid="ARTd1-report"
                onClick={onReport}
                className="flex h-14 w-full items-center gap-4 px-6 text-left active:bg-[#F6F7F8]"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M4 15V3h16l-3 4 3 4H4M4 22v-7" />
                </svg>
                <span className="text-[16px] text-[#1A1A1A]">举报</span>
              </button>
            </li>
          )}
        </ul>

        {/* divider */}
        <div className="h-2 bg-[#F6F7F8]" />

        <button
          type="button"
          data-testid="ARTd1-actions-cancel"
          onClick={onClose}
          className="h-14 w-full text-center text-[16px] font-medium text-[#1A1A1A] active:bg-[#F6F7F8]"
        >
          取消
        </button>
      </div>
    </div>
  )
}
